import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
     Dialog,
      DialogTitle,
      DialogContent,
      DialogActions,
  CircularProgress,
  MenuItem,
  Select,
  InputLabel,
  FormControl,Menu,Grid, ListItemIcon, ListItemText,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { GlobalStyles } from "@mui/system";
import {  IconButton } from "@mui/material";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useAuth } from "../../../AuthProvider";


import ExcelJS from "exceljs";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import PresentToAllIcon from '@mui/icons-material/PresentToAll';
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import FilePresentIcon from '@mui/icons-material/FilePresent';
import { useLocation } from "react-router-dom";

const baseUrl=process.env.REACT_APP_API_BASE_URL
const AbsentStudentsList = () => {
  const navigate = useNavigate();
  const {oId,board,pId}=useAuth();
const { state } = useLocation();
const principalId = state?.PrincipalId;
  const PrincipalId = pId || principalId;

  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [originalData, setOriginalData] = useState([]); // Original API data

  const [loading, setLoading] = useState(true);
  // const [selectedClass, setSelectedClass] = useState("Class-I");
  // const [selectedSection, setSelectedSection] = useState("Section-A"); // Default to SECTION-A
  const [sscClassOptions, setSscClassOptions] = useState([]);
  const [sscSectionOptions, setSscSectionOptions] = useState([]);
  const [sscSelectedClass, setSscSelectedClass] = useState("");
  const [sscSelectedSection, setSscSelectedSection] = useState("");
  
  // INTERMEDIATE states
  const [interSectionOptions, setInterSectionOptions] = useState([]);
  const [interSelectedClass, setInterSelectedClass] = useState("");
  const [interSelectedSection, setInterSelectedSection] = useState("");
  const [courseOptions, setCourseOptions] = useState([]);
  const [selectedCourseType, setSelectedCourseType] = useState("");

  
const [mode, setMode] = useState("scrolling"); // "scrolling" or "classSection"
// console.log("selected mode :"+mode);
const [sscClassSectionMap, setSscClassSectionMap] = useState({});
const [hasFetchedOnce, setHasFetchedOnce] = useState(false); // new flag


  const [exportAnchorEl, setExportAnchorEl] = useState(null);
  const isExportMenuOpen = Boolean(exportAnchorEl);


   const [selectedDate, setSelectedDate] = useState("today");
    const [attendanceStats, setAttendanceStats] = useState(null);
    // State for custom date picker
      const [openCustomDialog, setOpenCustomDialog] = useState(false);
      // const [selectedDate, setSelectedDate] = useState("currentMonth");
        const [startDate, setStartDate] = useState("");


         // Handle date filter change
const handleDateChange = (event) => {
  const selectedValue = event.target.value;
  setSelectedDate(selectedValue);
  ///dateFilter===selectedValue
  if (selectedValue === "customDate") {
    setOpenCustomDialog(true); // Open custom date selection dialog
  }
};


const handleGetButtonClick = () => {
  if (startDate ) {
    console.log("Fetching data for:", startDate);
    setSelectedDate("customDate"); // This updates UI but doesn't fetch data
    fetchPresentData(); // Manually fetch data only when clicking "Get"
    setOpenCustomDialog(false);
  } else {
    console.error("Start Date or End Date is missing");
  }
};


// Fetch all Absent COUNT based on date range
const fetchPresentData = async () => {
  // if (!baseUrl || !oId || !pId || !sscSelectedClass || !sscSelectedSection) {
  //   console.warn("Missing required parameters to fetch data.");
  //   setLoading(false);
  //   return;
  // }

  if (!baseUrl) {
  console.error("❌ Missing required parameter: baseUrl");
  setLoading(false);
  return;
}
if (!oId) {
  console.error("❌ Missing required parameter: oId");
  setLoading(false);
  return;
}
if (!pId) {
  console.error("❌ Missing required parameter: pId");
  setLoading(false);
  return;
}
if (!sscSelectedClass) {
  console.error("❌ Missing required parameter: sscSelectedClass");
  setLoading(false);
  return;
}
if (!sscSelectedSection) {
  console.error("❌ Missing required parameter: sscSelectedSection");
  setLoading(false);
  return;
}


  setLoading(true);
  try {
    let endpoint = "";

    switch (selectedDate) {
      case "today":
        endpoint = `${baseUrl}/api/admissionDashBoard/principal/countAllStudentsTodaysAttendance/${oId}/${pId}?romanNumberClass=${sscSelectedClass}&sections=${sscSelectedSection}`;
        break;
      case "yesterday":
        endpoint = `${baseUrl}/api/admissionDashBoard/principal/countAllStudentsYesterdaysAttendance/${oId}/${pId}?romanNumberClass=${sscSelectedClass}&sections=${sscSelectedSection}`;
        break;

      case "customDate":
        if (startDate) {
          const formattedCustomDate = new Date(startDate).toISOString().split("T")[0];
          endpoint = `${baseUrl}/api/admissionDashBoard/principal/countAllStudentsCustomAttendance/${oId}/${pId}/${formattedCustomDate}?romanNumberClass=${sscSelectedClass}&sections=${sscSelectedSection}`;
        } else {
          console.error("Custom date is missing.");
          setLoading(false);
          return;
        }
        break;

      default:
        console.warn("No matching date filter selected.");
        setLoading(false);
        return;
    }

    const response = await fetch(endpoint);
    if (!response.ok) {
      console.log(`Failed to fetch data: ${response.status}`);
      setLoading(false);
      return;
    }

    const data = await response.json();
    setAttendanceStats(data);

  } catch (error) {
    console.error("Error fetching attendance data:", error);
  } finally {
    setLoading(false);
  }
};

// Automatically fetch when dependencies change
useEffect(() => {
  fetchPresentData();
}, [oId, pId, selectedDate, startDate, sscSelectedClass, sscSelectedSection]);




  
  const handleExportClick = (event) => {
    setExportAnchorEl(event.currentTarget);
  };
  
  const handleExportClose = () => {
    setExportAnchorEl(null);
  };
  // const handleClose = () => {
  //   setExportAnchorEl(null);
  // };



    
//fetch table scrolling data
  // const fetchGetAllTableData = async () => {
  //   setLoading(true);
  //   setHasFetchedOnce(false);
  //   try {
  //     const response = await fetch(
  //       `${baseUrl}/api/admissionDashBoard/pr/getAllTodayAbsentStudentsOverAllStudent/${oId}/${PrincipalId}`
  //     );
  //     const data = await response.json();
  //     if (Array.isArray(data)) {
  //      setOriginalData(data);
  //     setFilteredData(data);
  //       // setUniqueCourseType([...new Set(data.map(item => item.course))]);
  //     } else {
  //       setOriginalData([]);
  //     setFilteredData([]);
  //     }
  
  //   } catch (error) {
  //     console.error("Error fetching  table data:", error);
  //   } finally {
  //     setLoading(false);
  //     setHasFetchedOnce(true); // mark as fetched
  //   }
  // };
  
  // useEffect(() => {
  //   fetchGetAllTableData();
  // }, [oId]);


// -------------------------------------------
//           For SSC functions
// -------------------------------------------


// ---- Fetch Class + Sections for SSC (School) ----
const fetchClassRegistrationData = async () => {
  try {
    const response = await fetch(
      `${baseUrl}/api/dynamic-classReg/class-registrations/${oId}/${PrincipalId}`
    );
    const data = await response.json();

    if (response.ok && Array.isArray(data)) {
      const classSectionMap = {};

      data.forEach((item) => {
        const className = item.classRegistration;
        const sections = item.sections.split(",").map((s) => s.trim());

        if (!classSectionMap[className]) {
          classSectionMap[className] = new Set();
        }

        sections.forEach((sec) => classSectionMap[className].add(sec));
      });

      const classes = Object.keys(classSectionMap);
      setSscClassOptions(classes);
      setSscClassSectionMap(classSectionMap);

      if (classes.length) {
        const defaultClass = classes[0];
        const sectionArray = [...classSectionMap[defaultClass]];

        setSscSelectedClass(defaultClass);
        setSscSectionOptions(sectionArray);
        setSscSelectedSection(sectionArray[0] || ""); // ✅ Select first section
      } else {
        setSscSelectedClass("");
        setSscSectionOptions([]);
        setSscSelectedSection("");
      }
    }
  } catch (error) {
    console.error("Error fetching SSC data:", error);
  }
};


// ---- Fetch Table Data for SSC ----
const fetchClassSectionTableData = async () => {
  if ( !PrincipalId || !sscSelectedClass || !sscSelectedSection) {
    console.warn("Missing required parameters to fetch class/section table data.");
    setFilteredData([]);
    setOriginalData([]);
    setLoading(false);
    return;
  }

  setLoading(true);
  try {
    let endpoint = "";

    switch (selectedDate) {
      case "today":
        endpoint = `${baseUrl}/api/admissionDashBoard/pr/getAllTodayAbsentStudents/${oId}/${PrincipalId}?romanNumberClass=${sscSelectedClass}&sections=${sscSelectedSection}`;
        break;

      case "yesterday":
        endpoint = `${baseUrl}/api/admissionDashBoard/pr/getAllYesterdayAbsentStudents/${oId}/${PrincipalId}?romanNumberClass=${sscSelectedClass}&sections=${sscSelectedSection}`;
        break;

      case "customDate":
  if (startDate) {
    const formattedCustomDate = new Date(startDate).toISOString().split("T")[0]; // yyyy-mm-dd
    endpoint = `${baseUrl}/api/admissionDashBoard/pr/getAllCustomAbsentStudents/${oId}/${PrincipalId}/${formattedCustomDate}?romanNumberClass=${sscSelectedClass}&sections=${sscSelectedSection}`;
      } else {
        console.error("Custom date is missing.");
        setLoading(false);
        return;
      }
      break;


      default:
        console.warn("Invalid or missing selectedDate. Cannot fetch data.");
        setLoading(false);
        return;
    }

    const response = await fetch(endpoint);
    if (!response.ok) {
      console.error(`Failed to fetch data: ${response.status}`);
      setOriginalData([]);
      setFilteredData([]);
      return;
    }

    const data = await response.json();
    if (Array.isArray(data)) {
      setOriginalData(data);
      setFilteredData(data);
    } else {
      setOriginalData([]);
      setFilteredData([]);
    }
  } catch (error) {
    console.error("Error fetching SSC table data:", error);
  } finally {
    setLoading(false);
  }
};

// // Automatically fetch when dependencies change
useEffect(() => {
    if (board === "SSC") {
      if (sscSelectedClass && sscSelectedSection ) {
        fetchClassSectionTableData();
      } else {
        setOriginalData([])
        setFilteredData([]);
        setLoading(false);
      }
    }
  // fetchClassSectionTableData();
}, [oId, PrincipalId, sscSelectedClass, sscSelectedSection, selectedDate, startDate]);




// -------------------------------------------
//           For Intermediate functions
// -------------------------------------------

// ---- Fetch Courses for INTERMEDIATE ----
const fetchCourseData = async () => {
  if(!interSelectedClass) return;
  try {
    const response = await fetch(`${baseUrl}/api/dynamic-classReg/getAllcoursesAccordingClasses/${PrincipalId}?romanNumberClass=${interSelectedClass}`);
    const data = await response.json();
    if (response.ok && Array.isArray(data)) {
      setCourseOptions(data);
      // if (!selectedCourseType) {
      //   setSelectedCourseType(data[0] || "");
      // }
    } else {
      setCourseOptions([]);
    }
  } catch (error) {
    console.error("Error fetching course data:", error);
    setCourseOptions([]);
  }
};

// ---- Fetch Sections for INTERMEDIATE ----
const fetchSectionsData = async () => {
  if (!interSelectedClass || !selectedCourseType) {
    setInterSectionOptions([]);
    return;
  }
  try {
    const response = await fetch(
      `${baseUrl}/api/dynamic-classReg/getAllClass-registrations/${interSelectedClass}/${selectedCourseType}/${PrincipalId}`
    );
    const data = await response.json();
    if (response.ok && Array.isArray(data) && data.length > 0) {
      const sectionsString = data[0].sections;  // because your data is like [{ sections: "Section-A,Section-B" }]
      const sections = sectionsString.split(",").map(section => section.trim());
      
      setInterSectionOptions(sections);

      if (sections.length > 0) {
        setInterSelectedSection(sections[0]);
      } else {
        setInterSelectedSection("");
      }
    } else {
      setInterSectionOptions([]);
      setInterSelectedSection("");
    }
  } catch (error) {
    console.error("Error fetching INTERMEDIATE data:", error);
  }
};




// ---- Fetch Table Data for INTERMEDIATE ----
const fetchCourseClassSectionTableData = async () => {
  if (!selectedCourseType || !interSelectedClass || !interSelectedSection) {
    setFilteredData([]);
    setOriginalData([]);
    setLoading(false);
    return;
  }
  setLoading(true);
  try {
    const response = await fetch(
      `${baseUrl}/api/admissionDashBoard/pr/getAllTodayAbsentStudents/${oId}/${PrincipalId}?course=${selectedCourseType}&romanNumberClass=${interSelectedClass}&sections=${interSelectedSection}`
    );
    const data = await response.json();
    if (Array.isArray(data)) {
      setOriginalData(data);
      setFilteredData(data);
      // setUniqueCourseType([...new Set(data.map(item => item.course))]);
    } else {
      setOriginalData([]);
      setFilteredData([]);
    }
  } catch (error) {
    console.error("Error fetching INTERMEDIATE table data:", error);
  } finally {
    setLoading(false);
  }
};



useEffect(() => {
  const loadClassData = async () => {
    if (board === "INTERMEDIATE") {
      await fetchSectionsData();
    } else if (board === "SSC") {
      await fetchClassRegistrationData();
    }
  };
  loadClassData();
}, [board,interSelectedClass, selectedCourseType, oId]);  // Removed selectedClass dependency here







// Fetch course options if board is INTERMEDIATE
useEffect(() => {
  if (board === "INTERMEDIATE") {
    fetchCourseData();
  }
}, [interSelectedClass,board, oId]);


// useEffect(() => {
//   const fetchData = () => {
//     // if (board === "SSC") {
//     //   if (sscSelectedClass && sscSelectedSection ) {
//     //     fetchClassSectionTableData();
//     //   } else {
//     //     setOriginalData([])
//     //     setFilteredData([]);
//     //     setLoading(false);
//     //   }
//     } else if (board === "INTERMEDIATE") {
//       if (selectedCourseType && interSelectedClass && interSelectedSection ) {
//         fetchCourseClassSectionTableData();
//       } else {
//         setOriginalData([])
//         setFilteredData([]);
//         setLoading(false);
//       }
//     }
//   };

//   fetchData();
// }, [board, sscSelectedClass, sscSelectedSection, selectedCourseType, interSelectedClass, interSelectedSection,PrincipalId,selectedDate, startDate]);
 
useEffect(() => {
  const fetchData = () => {
    if (board === "INTERMEDIATE") {
      if (selectedCourseType && interSelectedClass && interSelectedSection) {
        fetchCourseClassSectionTableData();
      } else {
        setOriginalData([]);
        setFilteredData([]);
        setLoading(false);
      }
    }
  };

  fetchData();
}, [
  board,
  sscSelectedClass,
  sscSelectedSection,
  selectedCourseType,
  interSelectedClass,
  interSelectedSection,
  PrincipalId,
  selectedDate,
  startDate,
]);




  useEffect(() => {
    if (!searchQuery) {
      setFilteredData(originalData); // Reset to original data if search query is empty
      return;
    }
  
    const result = originalData.filter((student) => {
      const searchTerm = searchQuery.toLowerCase();
      return (
        String(student.customAdmissionNumber).toLowerCase().includes(searchTerm) || // Add search by admission number
        String(student.surName).toLowerCase().includes(searchTerm) ||
        String(student.firstName).toLowerCase().includes(searchTerm) ||
        String(student.lastName).toLowerCase().includes(searchTerm) ||
        String(student.primaryContact).includes(searchTerm)
      );
    });
  
    setFilteredData(result);
  }, [searchQuery, originalData]);
  
  

  


const exportToExcel = () => {

  const isIntermediate = board === "INTERMEDIATE";
    const dynamicKey = isIntermediate ? "Year" : "Class";
  const processedData = filteredData.map(({ 
    customAdmissionNumber, admissionDate,course, romanNumberClass, sections, firstName, lastName, 
    gender, fathersFirstName, fathersLastName, mothersFirstName, mothersLastName, primaryContact ,status
  }) => ({
    AdmissionNumber: customAdmissionNumber,  
    AdmissionDate: admissionDate,  
    ...(isIntermediate ? { Course: course } : {}),
      [dynamicKey]: romanNumberClass,
    Section: sections,
    StudentName: `${firstName} ${lastName}`,
    Gender: gender,
    FatherName: `${fathersFirstName} ${fathersLastName}`,
    MotherName: `${mothersFirstName} ${mothersLastName}`,
    Phone: primaryContact,
    status:status,
  }));

  const workbook = new ExcelJS.Workbook();
  // const worksheet = workbook.addWorksheet(
  //   board === "INTERMEDIATE"
  //     ? `${interSelectedClass}-${interSelectedSection}_AbsentStudentsList`
  //     : `${sscSelectedClass}-${sscSelectedSection}_AbsentStudentsList`
  // );
const worksheet = workbook.addWorksheet(
  (board === "INTERMEDIATE" && interSelectedClass && interSelectedSection)
    ? `${interSelectedClass}-${interSelectedSection}_AbsentStudentsList`
    : (board === "SSC" && sscSelectedClass && sscSelectedSection)
    ? `${sscSelectedClass}-${sscSelectedSection}_AbsentStudentsList`
    : "AbsentStudentsList"
);




  // Add headers
  worksheet.columns = [
    { header: "Admission No", key: "AdmissionNumber", width: 15 },
    { header: "Admission Date", key: "AdmissionDate", width: 15 },
    ...(board === "INTERMEDIATE"
      ? [{ header: "Course", key: "Course", width: 15 }]
      : []),
    { header: isIntermediate ? "Year" : "Class", key: dynamicKey, width: 15 },
    { header: "Section", key: "Section", width: 10 },
    { header: "Student Name", key: "StudentName", width: 25 },
    { header: "Gender", key: "Gender", width: 10 },
    { header: "Father Name", key: "FatherName", width: 20 },
    { header: "Mother Name", key: "MotherName", width: 20 },
    { header: "Phone", key: "Phone", width: 15 },
    { header: "status", key: "status", width: 15 },
  ];

  // Add data to worksheet
  processedData.forEach((data) => {
    worksheet.addRow(data);
  });

  // Style headers
  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true };
    cell.alignment = { horizontal: "center" };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "87CEEB" }, // Light Blue Header
    };
  });

  // Write and download file
  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
  //   link.download = board === "INTERMEDIATE"
  //   ? `${interSelectedClass}-${interSelectedSection}_AbsentStudentsList.xlsx`
  //   : `${sscSelectedClass}-${sscSelectedSection}_AbsentStudentsList.xlsx`;
  //   link.click();
  // });

  link.download = 
  (board === "INTERMEDIATE" && interSelectedClass && interSelectedSection)
    ? `${interSelectedClass}-${interSelectedSection}_AbsentStudentsList.xlsx`
    : (board === "SSC" && sscSelectedClass && sscSelectedSection)
    ? `${sscSelectedClass}-${sscSelectedSection}_AbsentStudentsList.xlsx`
    : "AbsentStudentsList.xlsx";


      link.click();
    });

  handleExportClose();
};


// Export to PDF
const exportToPDF = () => {
  const doc = new jsPDF();

  // Title
  doc.setFontSize(16);
  doc.setFont("helvetica", "bold");
  // if (board === "INTERMEDIATE") {
  //   doc.text(`${interSelectedClass}-${interSelectedSection} Absent Students List`, 10, 8);
  // } else {
  //   doc.text(`${sscSelectedClass}-${sscSelectedSection} Absent Students List`, 10, 8);
  // }

   if (board === "INTERMEDIATE" && interSelectedClass && interSelectedSection) {
  doc.text(`${interSelectedClass}-${interSelectedSection} Absent Students List`, 10, 8);
} else if (board === "SSC" && sscSelectedClass && sscSelectedSection) {
  doc.text(`${sscSelectedClass}-${sscSelectedSection} Absent Students List`, 10, 8);
} else {
  doc.text(`Absent Students List`, 10, 8);
}

  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.text("Generated On: ", 14, 16);
  doc.setFont("helvetica", "bold");
  doc.text(new Date().toLocaleDateString(), 40, 16);

  // Define headers conditionally
  const headers = board === "INTERMEDIATE"
    ? [
        "S.No", "Admission No", "Admission Date", "Course", "Year", "Section",
        "Student Name", "Gender", "Father Name", "Mother Name", "Phone"
      ]
    : [
        "S.No", "Admission No", "Admission Date", "Class", "Section",
        "Student Name", "Gender", "Father Name", "Mother Name", "Phone"
      ];

  // Define body rows
  const bodyData = filteredData.map((row, index) => {
    const rowData = [
      index + 1,
      row.customAdmissionNumber,
      row.admissionDate
    ];

    if (board === "INTERMEDIATE") {
      rowData.push(row.course); // Add course only for INTERMEDIATE
    }

    rowData.push(
      `${row.romanNumberClass}`,
      row.sections,
      `${row.firstName} ${row.lastName}`,
      row.gender,
      `${row.fathersFirstName} ${row.fathersLastName}`,
      `${row.mothersFirstName} ${row.mothersLastName}`,
      row.primaryContact
    );

    return rowData;
  });

  // Render the table
  doc.autoTable({
    startY: 20,
    head: [headers],
    body: bodyData,
    styles: {
      lineWidth: 0.2,
      lineColor: "#B6B9CD",
    },
    headStyles: {
      fillColor: [63, 81, 181],
      textColor: [255, 255, 255],
      halign: "center",
    },
    bodyStyles: {
      halign: "center",
    },
    theme: "grid",
  });

  // Save file
  // if (board === "INTERMEDIATE") {
  //   doc.save(`${interSelectedClass}-${interSelectedSection}_AbsentStudentsList.pdf`);
  // } else {
  //   doc.save(`${sscSelectedClass}-${sscSelectedSection}_AbsentStudentsList.pdf`);
  // }

   if (board === "INTERMEDIATE" && interSelectedClass && interSelectedSection) {
  doc.save(`${interSelectedClass}-${interSelectedSection}_AbsentStudentsList.pdf`);
} else if (board === "SSC" && sscSelectedClass && sscSelectedSection) {
  doc.save(`${sscSelectedClass}-${sscSelectedSection}_AbsentStudentsList.pdf`);
} else {
  doc.save(`AbsentStudentsList.pdf`);
}

  handleExportClose();
};




const exportToJSON = () => {
  const jsonString = `data:text/json;charset=utf-8,${encodeURIComponent(
    JSON.stringify(filteredData, null, 2)
  )}`;
  const link = document.createElement("a");
  link.href = jsonString;
  // if(board === "INTERMEDIATE") {
  //   link.download = `${interSelectedClass}-${interSelectedSection}_AbsentStudentsList.json`;
  // } else {
  //   link.download = `${sscSelectedClass}_${sscSelectedSection}_AbsentStudentsList.json`;
  // }



   if (
  board === "INTERMEDIATE" &&
  interSelectedClass &&
  interSelectedSection
) {
  link.download = `${interSelectedClass}-${interSelectedSection}_AbsentStudentsList.json`;
} else if (
  board === "SSC" &&
  sscSelectedClass &&
  sscSelectedSection
) {
  link.download = `${sscSelectedClass}_${sscSelectedSection}_AbsentStudentsList.json`;
} else {
  link.download = `AbsentStudentsList.json`;
}


  link.click();
  handleExportClose();
};



  return (
    <Box sx={{ mt: "5%", mr: "1%", ml: "1%" }}>
      <Card
        sx={{
          marginTop:"60px",
          width: "100%",
          borderRadius: 3,
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        }}
      >
        <CardContent>
          {/* <Typography
            variant="h5"
            sx={{ fontWeight: "bold", mb: 3, textAlign: "center" }}
          >
            Student List
          </Typography> */}
           <Box display="flex" alignItems="center" sx={{ marginBottom: 2 }}>
            {/* Back Button and Heading */}
            <IconButton onClick={() => navigate(-1)} sx={{ color: '#2e2a54' }}>
              <KeyboardBackspaceIcon fontSize="medium" />
            </IconButton>
            <Typography variant="h4" component="h3" sx={{ fontWeight: 'bold' }}>
              Absent Students List
            </Typography>
          
            {/* Spacer to push export button to the right */}
            <Box sx={{ flexGrow: 1 }} />
          
            {/* Count and Export */}
            <Box display="flex" alignItems="center" gap={2}>
              {/* 👇 Present Students Count */}
            {/* {attendanceStats  && sscSelectedClass && sscSelectedSection && selectedDate && ( */}
  <Box
    sx={{
      display: 'flex',
      gap: 2,
      mt: 1,
    }}
  >
    {/* Total Students Box */}
    <Box
      sx={{
        backgroundColor: '#e3f2fd',
        padding: '8px 12px',
        borderRadius: '8px',
        minWidth: 140,
        boxShadow: 1,
        textAlign: 'center',
      }}
    >
      <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#000' }}>
        Total Students:{" "}
        <Box component="span" sx={{ color: '#1565c0', fontWeight: 'bold' }}>
          {attendanceStats?.totalStudents}
        </Box>
      </Typography>
    </Box>

    

    {/* Absent Students Box */}
    <Box
      sx={{
        backgroundColor: '#ffebee',
        padding: '8px 12px',
        borderRadius: '8px',
        minWidth: 140,
        boxShadow: 1,
        textAlign: 'center',
      }}
    >
      <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#000' }}>
        Absent Students:{" "}
        <Box component="span" sx={{ color: '#c62828', fontWeight: 'bold' }}>
          {attendanceStats?.absentStudents}
        </Box>
      </Typography>
    </Box>
  </Box>
{/* )} */}

          
              {/* Export Button */}
              <Button
                variant="contained"
                onClick={handleExportClick}
                style={{ backgroundColor: '#3C3972', fontWeight: 'bold' }}
                startIcon={<PresentToAllIcon />}
              >
                Export
              </Button>
          
              {/* Export Menu */}
              <Menu
                anchorEl={exportAnchorEl}
                open={isExportMenuOpen}
                onClose={handleExportClose}
                sx={{
                  "& .MuiPaper-root": {
                    backgroundColor: "#f5f5f5",
                    borderRadius: "8px",
                  },
                }}
              >
                {/* Menu Items */}
                <MenuItem onClick={exportToExcel} sx={{ color: "#3f51b5", fontWeight: "bold", "&:hover": { backgroundColor: "#e8f0fe" } }}>
                  <ListItemIcon sx={{ color: '#00796b' }}>
                    <SimCardDownloadIcon />
                  </ListItemIcon>
                  <ListItemText primary="Excel" sx={{ fontWeight: 'bold', color: '#00796b' }} />
                </MenuItem>
          
                <MenuItem onClick={exportToPDF} sx={{ color: "#d32f2f", fontWeight: "bold", "&:hover": { backgroundColor: "#fdecea" } }}>
                  <ListItemIcon sx={{ color: '#d32f2f' }}>
                    <PictureAsPdfIcon />
                  </ListItemIcon>
                  <ListItemText primary="PDF" sx={{ fontWeight: 'bold', color: '#d32f2f' }} />
                </MenuItem>
          
                <MenuItem onClick={exportToJSON} sx={{ color: "#388e3c", fontWeight: "bold", "&:hover": { backgroundColor: "#e8f5e9" } }}>
                  <ListItemIcon sx={{ color: '#6a1b9a' }}>
                    <FilePresentIcon />
                  </ListItemIcon>
                  <ListItemText primary="JSON" sx={{ fontWeight: 'bold', color: '#6a1b9a' }} />
                </MenuItem>
              </Menu>
            </Box>
          </Box>



<Box
  display="flex"
  flexWrap="wrap"
  alignItems="center"
  mb={3}
>
  {/* Search */}
  <TextField
    label="Search by Name Or Mobile No"
    variant="outlined"
    size="small"
    value={searchQuery}
    onChange={(e) => setSearchQuery(e.target.value)}
    sx={{ marginRight: 2 }}
  />

 
  {/* SSC Filters */}
  {board === "SSC" && (
    <>
      <FormControl size="small" sx={{ minWidth: 120, marginRight: 2 }}>
        <InputLabel id="class-select-label">Select Class</InputLabel>
        <Select
          labelId="class-select-label"
          value={sscSelectedClass}
          onChange={(e) => {
            const selected = e.target.value;
            setSscSelectedClass(selected);
            // setMode("classSection");
            const sections = sscClassSectionMap[selected] ? Array.from(sscClassSectionMap[selected]) : [];
            setSscSectionOptions(sections);
            setSscSelectedSection(sections.includes("Section-A") ? "Section-A" : sections[0] || "");
          }}
          label="Select Class"
          sx={{ height: 35 }}
        >
          {sscClassOptions.map((cls) => (
            <MenuItem key={cls} value={cls}>
              {cls}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl size="small" sx={{ minWidth: 120, marginRight: 2 }}>
        <InputLabel id="section-select-label">Select Section</InputLabel>
        <Select
          labelId="section-select-label"
          value={sscSelectedSection}
          onChange={(e) => {
            setSscSelectedSection(e.target.value);
            // setMode("classSection");
          }}
          label="Select Section"
          sx={{ height: 35 }}
        >
          {sscSectionOptions.length === 0 ? (
            <MenuItem value="" disabled>
              Select Class
            </MenuItem>
          ) : (
            sscSectionOptions.map((section) => (
              <MenuItem key={section} value={section}>
                {section}
              </MenuItem>
            ))
          )}
        </Select>
      </FormControl>
    </>
  )}

  {/* INTERMEDIATE Filters */}
  {board === "INTERMEDIATE" && (
    <>
      <FormControl size="small" sx={{ minWidth: 140, marginRight: 2 }}>
        <InputLabel id="intermediate-class-select-label">Select Year</InputLabel>
        <Select
          labelId="intermediate-class-select-label"
          value={interSelectedClass}
          onChange={(e) => setInterSelectedClass(e.target.value)}
          label="Select Year"
          sx={{ height: 35 }}
        >
          <MenuItem value="Inter-1st-Year">Inter-1st-Year</MenuItem>
          <MenuItem value="Inter-2nd-Year">Inter-2nd-Year</MenuItem>
        </Select>
      </FormControl>

      <FormControl size="small" sx={{ minWidth: 140, marginRight: 2 }}>
        <InputLabel id="course-type-label">Select Course</InputLabel>
        <Select
          labelId="course-type-label"
          value={selectedCourseType}
          onChange={(e) => {
            setSelectedCourseType(e.target.value);
            // setMode("classSection");
          }}
          label="Select Course"
          sx={{ height: 35 }}
        >
          {courseOptions.map((course, index) => (
            <MenuItem key={index} value={course}>
              {course}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl size="small" sx={{ minWidth: 120, marginRight: 2 }}>
        <InputLabel id="intermediate-section-select-label">Select Section</InputLabel>
        <Select
          labelId="intermediate-section-select-label"
          value={interSelectedSection || ""}
          onChange={(e) => {
            setInterSelectedSection(e.target.value);
            // setMode("classSection");
          }}
          label="Select Section"
          sx={{ height: 35 }}
        >
          {interSectionOptions.length === 0 ? (
            <MenuItem value="" disabled>
              Select Year and Course
            </MenuItem>
          ) : (
            interSectionOptions.map((section, index) => (
              <MenuItem key={index} value={section}>
                {section}
              </MenuItem>
            ))
          )}
        </Select>
      </FormControl>
    </>
  )}

   {/* Date Selector */}
   <FormControl size="small" sx={{ width: 120, marginRight: 2 }}>
    <InputLabel id="date-select-label">Select Date</InputLabel>
    <Select
      labelId="date-select-label"
      value={selectedDate}
      onChange={(e) => {
        const value = e.target.value;
        setSelectedDate(value);
        handleDateChange(e); // still call your custom logic
  
        // Call fetch function if today is selected
        // if (value === 'today') {
        //    if (board === "SSC") {
        //   setSscSelectedClass("");
        //   setSscSelectedSection("");
        // } else if (board === "INTERMEDIATE") {
        //   setInterSelectedClass("");
        //   setSelectedCourseType("");
        //   setInterSelectedSection("");
        // }
        //   // fetchGetAllTableData();
        // }
      }}
      onOpen={() => {
        if (selectedDate === 'customDate') {
          setSelectedDate('');
        }
      }}
      label="Select Date"
    >
      <MenuItem value="today">Today</MenuItem>
      <MenuItem value="yesterday">Yesterday</MenuItem>
      <MenuItem value="customDate">Custom Date</MenuItem>
    </Select>
  </FormControl>


  {/* Fetch Button */}
  {/* <Button
    variant="outlined"
    color="primary"
    onClick={() => {
      if (board === "SSC") {
        setSscSelectedClass("");
        setSscSelectedSection("");
      } else if (board === "INTERMEDIATE") {
        setInterSelectedClass("");
        setSelectedCourseType("");
        setInterSelectedSection("");
      }
       setSelectedDate(""); 
      setMode("scrolling");
      fetchGetAllTableData();
    }}
    sx={{ marginLeft: 1 }}
  >
    Fetch OverAll Data
  </Button> */}

  {/* Spacer */}
  <Box sx={{ flexGrow: 1 }} />

  {/* Optional: Right aligned button (uncomment if needed) */}
  {/* <Button
    variant="contained"
    sx={{
      backgroundColor: "#4caf50",
      color: "white",
      "&:hover": { backgroundColor: "#388e3c" },
    }}
    onClick={() => navigate("/NewAdmissionForm")}
  >
    New Admission
  </Button> */}
</Box>


<GlobalStyles
          styles={{
            '.custom-sidebar-scrollbar': {
              scrollbarWidth: 'thin', // For Firefox
              scrollbarColor: 'grey #e0e0e0',
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar': {
              width: '6px', // For WebKit-based browsers
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar-track': {
              background: '#f1f1f1', // Track color
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb': {
              backgroundColor: 'grey', // Thumb color
              borderRadius: '10px',
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover': {
              backgroundColor: '#555',
            },
          }}
        />

          <TableContainer
            component={Paper}
            sx={{
              borderRadius: 2,
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              maxHeight: "800px",
              overflow: "auto",

            }}
             className="custom-sidebar-scrollbar"
          >
            <Table stickyHeader>
  <TableHead  >
    <TableRow >
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" ,backgroundColor: "#fff9c4",fontWeight:'Bold' }}>S.No</TableCell>
      {/* <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px" , textAlign: "center",backgroundColor: "#fff9c4",fontWeight:'Bold'  }}>Admission No</TableCell> */}
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px" , textAlign: "center",backgroundColor: "#fff9c4",fontWeight:'Bold'  }}>Date</TableCell>
      {/* <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px" , textAlign: "center",backgroundColor: "#fff9c4" ,fontWeight:'Bold' }}>Admission Date</TableCell> */}
      {/* <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px" }}>Admission Number</TableCell> */}
      {(board === "INTERMEDIATE" ) && (
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      backgroundColor: "#fff9c4",
                      textAlign: "center",
                      fontWeight: "Bold",
                    }}
                  >
                    Course
                  </TableCell>
                  )}
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px",backgroundColor: "#fff9c4", textAlign: "center"  ,fontWeight:'Bold' }}>{board === "INTERMEDIATE" ? "Year" : "Class"}</TableCell>
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px",backgroundColor: "#fff9c4", textAlign: "center"  ,fontWeight:'Bold' }}>Section</TableCell>
      
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" , whiteSpace: "nowrap",backgroundColor: "#fff9c4", overflow: "hidden", textOverflow: "ellipsis" ,fontWeight:'Bold' }}>Name</TableCell>
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" , whiteSpace: "nowrap",backgroundColor: "#fff9c4", overflow: "hidden", textOverflow: "ellipsis" ,fontWeight:'Bold' }}>Father Name</TableCell>
      {/* <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" , whiteSpace: "nowrap", backgroundColor: "#fff9c4",overflow: "hidden", textOverflow: "ellipsis" ,fontWeight:'Bold' }}>Mother Name</TableCell> */}
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" ,backgroundColor: "#fff9c4" ,fontWeight:'Bold' }}>Mobile No</TableCell>
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px",backgroundColor: "#fff9c4", textAlign: "center"  ,fontWeight:'Bold' }}>Gender</TableCell>
      
   
      {/* <TableCell sx={{ borderRight: "1px solid #ddd",padding: "4px" ,backgroundColor: "#fff9c4", textAlign: "center" ,fontWeight:'Bold' }}>Full Details</TableCell> */}
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px",backgroundColor: "#fff9c4", textAlign: "center"  ,fontWeight:'Bold' }}>Status</TableCell>
    </TableRow>
  </TableHead>
  {loading ?(
    <TableBody>
      <TableRow>
                      <TableCell colSpan={11} style={{ textAlign: "center", padding: "20px" }}>
                        <Box display="flex" flexDirection="column" alignItems="center">
                          <CircularProgress />
                          <Typography variant="body2" sx={{ mt: 1 }}>
                            Loading Data...
                          </Typography>
                        </Box>
                      </TableCell>
                    </TableRow>
      {/* <TableRow>
        <TableCell colSpan={13} sx={{ textAlign: "center" }}>
          <CircularProgress size={20} />
        </TableCell>
      </TableRow> */}
    </TableBody>
  ) : filteredData.length === 0 ? (
    <TableBody>
      <TableRow>
        <TableCell colSpan={13} sx={{ textAlign: "center" }}>
          No data found
        </TableCell>
      </TableRow>
    </TableBody>
  ) : (
   <TableBody>
  {filteredData.map((row, index) => (
    <TableRow key={row.admissionNumber} style={{
      backgroundColor: "white",
      transition: "background-color 0.3s",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.backgroundColor = "#f5f5f5"; // Hover color
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.backgroundColor = "white"; // Default color
    }}>
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>
        {index + 1}
      </TableCell>
      {/* <TableCell
  sx={{
    borderRight: "1px solid #ddd",
    padding: "4px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textAlign: "center",
    display: "flex",
    flexDirection: "column", // Stack items vertically
    justifyContent: "center", // Center the content vertically
    alignItems: "center", // Center the content horizontally
  }}
>
  <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
  <Avatar src={row.passPhoto} alt="Pass Photo" sx={{ width: 25, height: 25, objectFit: "cover" }} />
  <Typography sx={{ marginLeft: "8px" }}> {row.admissionNumber} </Typography>
  </Box>
</TableCell> */}

      {/* <TableCell sx={{borderRight: "1px solid #ddd", padding: "4px", textAlign: "center"  }}>
        {row.customAdmissionNumber}
      </TableCell> */}
      <TableCell sx={{borderRight: "1px solid #ddd", padding: "4px", textAlign: "center"  }}>
        {row.date}
      </TableCell>
      {/* <TableCell sx={{borderRight: "1px solid #ddd", padding: "4px", textAlign: "center"  }}>
        {row.admissionDate}
      </TableCell> */}
      {board === "INTERMEDIATE" && (
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        {row.course}
                      </TableCell>
                      )}
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>
      {row.romanNumberClass}
      </TableCell>
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>
        {row.sections}
      </TableCell>
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>{`${row.firstName} ${row.lastName}`}</TableCell>
 
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>
        {row.fathersFirstName || row.fathersLastName
          ? `${row.fathersFirstName || ""} ${row.fathersLastName || ""}`.trim()
          : "N/A"}
      </TableCell>
      
      {/* <TableCell
        sx={{
          borderRight: "1px solid #ddd",
          padding: "4px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          textAlign: "center",
        }}
      >
        {row.mothersFirstName || row.mothersLastName
          ? `${row.mothersFirstName || ""} ${row.mothersLastName || ""}`.trim()
          : "N/A"}
      </TableCell> */}
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>
        {row.primaryContact}
      </TableCell>
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>
        {row.gender || "N/A"}
      </TableCell>
      
      {/* <TableCell
sx={{ borderRight: "1px solid #ddd", padding: "4px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", textAlign: "center" }}
>
  <Button
    type="button"
    onClick={() =>
      navigate(`/StudentDetailView/${row.studentId}`)
      //   , {
      //   state: { student: row },
      // })
    }
    sx={{
      backgroundColor: "#1976d2",
      color: "white",
      fontSize: "0.6rem", // Reduces the font size
      // padding: "5px 10px",  // Reduces the padding
      height: "25px",       // Reduces the height
      "&:hover": {
        backgroundColor: "#1565c0",
      },
    }}
  >
    View
  </Button>
</TableCell> */}
 <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>
        <Button
            variant="outlined"
            color="error"
            style={{
              backgroundColor: "#ED3638",
              color: "#fff",
              fontWeight: "bold",
              textTransform: "none",
              borderRadius: "20px",
            }}
          >
             Absent{/* {row.status}  */}
          </Button>
       
      </TableCell>

    </TableRow>
  ))}
</TableBody>


  )}
</Table>

          </TableContainer>

           <>
                              {/* Custom Date Dialog code */}
                            
                           <Dialog
  open={openCustomDialog}
  onClose={() => setOpenCustomDialog(false)}
  fullWidth={false} 
  maxWidth={false}  
  sx={{
    '& .MuiDialog-paper': {
      width: '350px',      // ✅ fixed small width
      minHeight: '150px',  // ✅ adjust height as needed
      padding: '16px',
    },
  }}
>
  <DialogTitle sx={{ fontWeight: 'bold', fontSize: '15px' }}>
    Select Custom Date Range
  </DialogTitle>
  <DialogContent>
    <div style={{ display: 'flex', gap: '16px', marginTop: '10px' }}>
      <TextField
        label="Select Date"
        type="date"
        InputLabelProps={{ shrink: true }}
        value={startDate}
        onChange={(e) => setStartDate(e.target.value)}
        fullWidth
      />
    </div>
  </DialogContent>
  <DialogActions>
    <Button
      onClick={() => setOpenCustomDialog(false)}
      variant="outlined"
      sx={{ minWidth: '60px' }}
    >
      Cancel
    </Button>
    <Button
      onClick={() => {
        if (startDate) {
          handleGetButtonClick();
        } else {
          alert('Please select Date.');
        }
      }}
      sx={{
        backgroundColor: '#3C3972',
        color: '#fff',
        '&:hover': { backgroundColor: '#3C3972' },
        minWidth: '60px'
      }}
      variant="outlined"
    >
      Apply
    </Button>
  </DialogActions>
</Dialog>
                            </>
        </CardContent>
      </Card>
    </Box>
  );
};

export default AbsentStudentsList;